import type { FC } from "react";
import { Box, Stack, Typography } from "@mui/material";

type AssistantThinkingIndicatorProps = { label: string; Glyph?: FC<{ size: number }>; pulses?: boolean };

export const AssistantThinkingIndicator = ({ label, Glyph, pulses }: AssistantThinkingIndicatorProps) => (
  <Stack direction="row" aria-hidden="true" sx={{ gap: 1, alignItems: "center" }}>
    {Glyph && (
      <Box
        sx={{
          "display": "inline-flex",
          "color": "text.secondary",
          "animation": pulses ? "assistantPulse 1.6s ease-in-out infinite" : "none",
          "@keyframes assistantPulse": { "0%, 100%": { opacity: 1 }, "50%": { opacity: 0.4 } },
          "@media (prefers-reduced-motion: reduce)": { animation: "none" },
        }}
      >
        <Glyph size={16} />
      </Box>
    )}
    <Typography
      sx={{
        "display": "inline-block",
        "color": "transparent",
        "backgroundImage": theme =>
          `linear-gradient(90deg, ${theme.palette.text.secondary} 0%, ${theme.palette.text.disabled} 50%, ${theme.palette.text.secondary} 100%)`,
        "backgroundSize": "200% 100%",
        "backgroundClip": "text",
        "WebkitBackgroundClip": "text",
        "animation": "assistantShimmer 1.6s linear infinite",
        "@keyframes assistantShimmer": {
          from: { backgroundPosition: "100% 0" },
          to: { backgroundPosition: "-100% 0" },
        },
        "@media (prefers-reduced-motion: reduce)": {
          animation: "none",
          color: "text.secondary",
          backgroundImage: "none",
        },
      }}
    >
      {`${label}…`}
    </Typography>
  </Stack>
);
